import React, { useState, useEffect, useCallback, useRef } from 'react';
import { jsPDF as JsPdf } from 'jspdf';
import { saveAs } from 'file-saver-es';
import { Workbook } from 'exceljs';

import './club_list.scss';

import {
  DataGrid,
  Sorting, Selection, HeaderFilter, Scrolling, SearchPanel,
  Export, Column, Toolbar, Item, LoadPanel

} from 'devextreme-react/data-grid';

import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';

import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridToXLSX } from 'devextreme/excel_exporter';


import { FormPopup, ClubNewForm, ClubPanel } from '../../components';
import { ClubStatus } from '../../components';

import { exportFormats, USER_STATUS_LIST } from '../../shared/constants';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { getApiToken } from '../../utils/authUtils.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate } from 'react-router-dom';
import { onExporting } from '../../utils/exporter';
import { useMsal } from "@azure/msal-react";



const dropDownOptions = { width: 'auto' };



export const ClubList = () => {
      const { instance, accounts } = useMsal();
  const [gridDataSource, setGridDataSource] = useState();

  const [clubId, setClubId] = useState();
  const [popupVisible, setPopupVisible] = useState(false);
  const [formDataDefaults, setFormDataDefaults] = useState({});
  const gridRef = useRef(null);
  const navigate = useNavigate();

  let newClubData;

  useEffect(() => {
    getApiToken(instance, accounts).then(token => {
      setGridDataSource({
        store: createStore({
          key: 'clubId',
          loadUrl: `${process.env.REACT_APP_serverEndpoint}/Club/Clubs`,
          insertUrl: `${process.env.REACT_APP_serverEndpoint}/Club/InsertClub`,
          updateUrl: `${process.env.REACT_APP_serverEndpoint}/Club/UpdateClub`,
          deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Club/DeleteClub`,
          onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.headers = {
              'Authorization': "Bearer " + token
            };
          },
        })
      });



    });

  }, []);

  const changePopupVisibility = useCallback((isVisble) => {
    setPopupVisible(isVisble);
  }, []);


  const onAddClubClick = useCallback(() => {
    setPopupVisible(true);
  }, []);

  const onRowClick = useCallback(({ data }) => {
    // setClubId(data.clubId);
    // setPanelOpened(true);
    const clubId = data.clubId;
    navigate(`/club/edit/${clubId}`);
  }, []);



  const refresh = useCallback(() => {
    gridRef.current?.instance().refresh();
  }, []);

  const onDataChanged = useCallback((data) => {
    newClubData = data;
  }, []);

  const onSaveClick = useCallback(() => {
    
    getApiToken(instance, accounts).then(token => {
      const datastore = createStore({
        key: 'clubId',
        insertUrl: `${process.env.REACT_APP_serverEndpoint}/Club/InsertClub`,
        onBeforeSend: (method, ajaxOptions) => {
          ajaxOptions.headers = {
            'Authorization': "Bearer " + token
          };
        },
      });

      datastore.insert(newClubData).then((data) => {

        notify({
          message: `Neuer Verein "${data.clubname}" gespeichert`,
          position: { at: 'bottom center', my: 'bottom center' }
        }
          ,
          'success'
        );
        setFormDataDefaults({ ...formDataDefaults });
        setPopupVisible(false);
        refresh();
      }).catch((error) => {
        notify({
          message: `Fehler beim Speichern des neuen Vereins "${newClubData.clubname}"`,
          position: { at: 'bottom center', my: 'bottom center' }
        },
          'error'
        );
      });
    });
  }, []);

  return (
    <div className='view club-list'>
      <div className='view-wrapper view-wrapper-club-list list-page'>
        <DataGrid
          className='grid theme-dependent'
          noDataText=''
          focusedRowEnabled
          height='100%'
          dataSource={gridDataSource}
          onRowClick={onRowClick}
          onExporting={onExporting}
          allowColumnReordering
          showBorders
          ref={gridRef}
          remoteOperations={true}
        >
          <LoadPanel showPane={false} />
          <SearchPanel visible placeholder='Verein suchen' />
          <Export enabled allowExportSelectedData formats={exportFormats} />
          <Selection
            selectAllMode='allPages'
            showCheckBoxesMode='always'
            mode='multiple'
          />
          <HeaderFilter visible />
          <Sorting mode='multiple' />
          <Scrolling mode='virtual' />
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Vereine</div>
            </Item>

            <Item location='after' locateInMenu='auto'>
              <Button
                icon='plus'
                text='Neuer Verein'
                type='default'
                stylingMode='contained'
                onClick={onAddClubClick}
              />
            </Item>
            <Item
              location='after'
              locateInMenu='auto'
              showText='inMenu'
              widget='dxButton'
            >
              <Button
                icon='refresh'
                text='Refresh'
                stylingMode='text'
                onClick={refresh}
              />
            </Item>
            <Item location='after' locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item name='exportButton' />
            <Item location='after' locateInMenu='auto'>
              <div className='separator' />
            </Item>
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>
          <Column dataField="clubname" caption="Verein" dataType="string" sortIndex={5} sortOrder='asc' hidingPriority={0} allowHiding={false} />
          <Column dataField="mail" caption="E-Mail" dataType="string" hidingPriority={4} allowHiding={true} />
          <Column dataField="lastname" caption="Nachname" dataType="string" hidingPriority={3} allowHiding={true} />
          <Column dataField="surname" caption="Vorname" dataType="string" hidingPriority={2} allowHiding={true} />
          <Column dataField="dsvId" caption="DSV-ID" dataType="string" hidingPriority={0} allowHiding={true} />
          <Column dataField="activ" caption="Aktiv" dataType="boolean" filterValue={true} hidingPriority={1} allowHiding={true} />




        </DataGrid>
        {/* <ClubPanel clubId={clubId} isOpened={isPanelOpened} changePanelOpened={changePanelOpened} changePanelPinned={changePanelPinned} /> */}
        <FormPopup title='Neuer Verein' visible={popupVisible} setVisible={changePopupVisibility} onSave={onSaveClick}>
          <ClubNewForm initData={formDataDefaults} onDataChanged={onDataChanged} />
        </FormPopup>
      </div>
    </div>
  );
};

